import ApiService from "@/core/services/api.service";
import farmerMock from "@/core/config/farmer.mock.json";

// action types
export const FARMER = "farmer";
export const FARMER_EXPORT = "farmer_export";
export const FARMER_SINGLE = "farmer_single";
export const FARMER_CREATE = "farmer_create";
export const FARMER_STORE = "farmer_store";
export const FARMER_SINGLE_UPDATED = "farmer_updated";
export const FARMER_DELETE = "farmer_delete";

// mutation types
export const SET_FARMER = "farmerData";
export const SET_FARMER_EXPORT = "farmerDataExport";
export const SET_FARMER_SINGLE = "farmerSingleData";
export const SET_FARMER_CREATE = "farmerCreateData";
export const SET_FARMER_STORE = "farmerStoreData";
export const SET_FARMER_SINGLE_UPDATED = "farmerSingleUpdated";
export const SET_FARMER_DELETE = "farmerDeleteData";

const state = {
    farmer: {},
    farmer_export: {},
    farmer_single: {},
    farmer_create: {},
    farmer_store: {},
    farmer_deleted: {},
    farmer_updated: {},
};

const getters = {
    getFarmer(state) {
        return state.farmer;
    },
    getFarmerExport(state) {
        return state.farmer_export;
    },
    getDeletedFarmer(state) {
        return state.farmer_deleted;
    },
    getCreateFarmer(state) {
        return state.farmer_create;
    },
    getStoreFarmer(state) {
        return state.farmer_store;
    },
    getSingleFarmer(state) {
        return state.farmer_single;
    },
    getSingleUpdatedFarmer(state) {
        return state.farmer_updated;
    }
};

const actions = {
    [FARMER](context, payload) {
        return ApiService.post("farmer-for-max-search-param", payload)
            .then(({data}) => {
                context.commit(SET_FARMER, data.response);
                return data.response;
            });
    },
    [FARMER_EXPORT](context, payload) {
        return ApiService.get("farmer-export", payload)
            .then(({data}) => {
                context.commit(SET_FARMER_EXPORT, data.response);
                return data.response;
            });
    },
    [FARMER_SINGLE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`farmer/${payload.id}`)
                .then(({data}) => {
                    context.commit(SET_FARMER_SINGLE, data.response.data);
                    resolve(data.response.data);
                });
        });
    },
    [FARMER_CREATE](context, get_latest) {
        return new Promise(resolve => {
            if (!get_latest) {
                resolve(farmerMock);
            } else {
                ApiService.get(`farmer/create`)
                    .then(({data}) => {
                        context.commit(SET_FARMER_CREATE, data.response.data);
                        resolve(data.response.data);
                    });
            }
        });
    },
    [FARMER_STORE](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`farmer`, payload)
                .then(({data}) => {
                    context.commit(SET_FARMER_STORE, data.response.data);
                    resolve(data.response.data);
                });
        });
    },
    [FARMER_SINGLE_UPDATED](context, payload) {
        return new Promise(resolve => {
            ApiService.put(`farmer/${payload.id}`, payload)
                .then(({data}) => {
                    context.commit(SET_FARMER_SINGLE_UPDATED, data.response.data);
                    resolve(data.response.data);
                });
        });
    },
    [FARMER_DELETE](context, payload) {
        return ApiService.delete(`farmer/${payload.id}`)
            .then(({data}) => {
                context.commit(SET_FARMER_DELETE, data.response.data);
                return data.response.data;
            });
    }
};

const mutations = {
    [SET_FARMER](state, data) {
        state.farmer = data;
    },
    [SET_FARMER_EXPORT](state, data) {
        state.farmer_export = data;
    },
    [SET_FARMER_DELETE](state, data) {
        state.farmer_deleted = data;
    },
    [SET_FARMER_SINGLE](state, data) {
        state.farmer_single = data;
    },
    [SET_FARMER_CREATE](state, data) {
        state.farmer_create = data;
    },
    [SET_FARMER_STORE](state, data) {
        state.farmer_store = data;
    },
    [SET_FARMER_SINGLE_UPDATED](state, data) {
        state.farmer_updated = data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
